module.exports = __webpack_public_path__ + "img/box3_active_bg.67ead5ad.png";